<template>
    <div class="p-3 pt-5 term-and-condition">
      <b-container>
        <b-row class="justify-content-end">
          <b-col xl="10" class="ml-auto mr-auto">
            <h3 class="text-center mb-4 fz-20">Specific Terms and Conditions for Virtual Account (VA) Service RCPAY Virtual Account Platform</h3>
            <div id="accordion">
                <section1></section1>
                <section2></section2>
                <section3></section3>
                <section4></section4>
                <section5></section5>
                <section6></section6>
                <section7></section7>
                <section8></section8>
                <section9></section9>
                <section10></section10>
                <section11></section11>
                <section12></section12>
                <section13></section13>
                <section14></section14>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>
  <script>
    
    import section1 from '@/components/termCondition/privacy/section1.vue'
    import section2 from '@/components/termCondition/privacy/section2.vue'
    import section3 from '@/components/termCondition/privacy/section3.vue'
    import section4 from '@/components/termCondition/privacy/section4.vue'
    import section5 from '@/components/termCondition/privacy/section5.vue'
    import section6 from '@/components/termCondition/privacy/section6.vue'
    import section7 from '@/components/termCondition/privacy/section7.vue'
    import section8 from '@/components/termCondition/privacy/section8.vue'
    import section9 from '@/components/termCondition/privacy/section9.vue'
    import section10 from '@/components/termCondition/privacy/section10.vue'
    import section11 from '@/components/termCondition/privacy/section11.vue'
    import section12 from '@/components/termCondition/privacy/section12.vue'
    import section13 from '@/components/termCondition/privacy/section13.vue'
    import section14 from '@/components/termCondition/privacy/section14.vue'

    export default {
        name: 'term-condition',
        data() {
            return {
            publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:''
            };
        },
        components:{
            section1,
            section2,
            section3,
            section4,
            section5,
            section6,
            section7,
            section8,
            section9,
            section10,
            section11,
            section12,
            section13,
            section14
        },
        methods: {
            
        },
        mounted () {
            
        }
    };
  </script>
<style>
ol,ul,li{
    font-size: 1rem;
    font-weight: 300;
    line-height: 2rem;
}
a{
    color: #5e72e4 !important;
    font-size: 1rem;
    font-weight: 300;
}
</style>